
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyList as SkyListElement, SkyListChangeDetail } from '@sky.ui/core/sky-list';
 
 

 
 export const SkyList = createComponent({
   displayName: 'SkyList',
   react: React,
   tagName: 'sky-list',
   elementClass: SkyListElement,
   events: {
     
     onListChange: 'list-change' as EventName<CustomEvent<SkyListChangeDetail>>,
   }
  });
export type * from '@sky.ui/core/sky-list';
